export default function CampaignSection() {
  const whatsapp = (msg: string) =>
    `https://wa.me/905412190629?text=${encodeURIComponent(msg)}`;

  return (
    <section id="kampanya" className="py-20 bg-[#FFF8F0]">
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <span className="text-[#D4AF37] text-xs font-semibold uppercase tracking-[0.3em] mb-3 block">Özel Fırsatlar</span>
          <h2 className="font-serif text-3xl md:text-4xl text-[#2D2D2D] mb-4">
            Sınırlı Süreli
            <br />
            <em className="text-[#D4AF37]">Kampanyalar</em>
          </h2>
          <div className="w-16 h-0.5 bg-[#D4AF37] mx-auto mt-4" />
        </div>

        {/* Main campaign card */}
        <div className="relative rounded-3xl overflow-hidden mb-8">
          <img
            src="https://readdy.ai/api/search-image?query=EMS%20slim%20body%20treatment%20luxury%20beauty%20clinic%20special%20offer%20premium%20pink%20and%20gold%20background%20elegant%20modern%20aesthetic%20medical%20spa%20campaign%20photo&width=1200&height=500&seq=camp001&orientation=landscape"
            alt="EMS Slim Kampanya"
            className="w-full h-64 md:h-80 object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-transparent" />

          {/* Pulsing badge */}
          <div className="absolute top-5 left-5">
            <div className="relative">
              <span className="bg-red-500 text-white text-xs font-bold px-3 py-1.5 rounded-full uppercase">
                Özel Kampanya
              </span>
              <span className="absolute inset-0 rounded-full bg-red-500 animate-ping opacity-30"></span>
            </div>
          </div>

          <div className="absolute bottom-5 right-5 bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl px-4 py-2 text-right">
            <p className="text-white/70 text-xs">Sınırlı Kontenjan</p>
            <p className="text-white font-bold text-sm">Son 5 kişi!</p>
          </div>

          <div className="absolute inset-0 flex items-center">
            <div className="px-8 md:px-12">
              <h3 className="font-serif text-white text-3xl md:text-4xl font-bold mb-2">EMS Slim</h3>
              <p className="text-white/80 text-sm mb-4 max-w-xs">30 dakikada 20.000 kas aktivasyonu ile vücut şekillendirme</p>
              <div className="flex items-baseline gap-3 mb-5">
                <span className="text-white/50 text-xl line-through">5.000 TL</span>
                <span className="text-white font-bold text-4xl md:text-5xl" style={{ textShadow: '0 0 20px rgba(212,175,55,0.5)' }}>
                  1.500 <span className="text-2xl">TL</span>
                </span>
              </div>
              <a
                href={whatsapp('EMS Slim kampanyası hakkında bilgi almak istiyorum.')}
                target="_blank"
                rel="nofollow noreferrer"
                className="inline-flex items-center gap-2 bg-[#D4AF37] text-white px-6 py-3 rounded-full text-sm font-semibold hover:bg-[#B8962E] transition-all hover:-translate-y-0.5 whitespace-nowrap"
              >
                <i className="ri-whatsapp-line"></i>
                Hemen Başvur
              </a>
            </div>
          </div>
        </div>

        {/* Mini campaign cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {[
            { name: 'Cilt Bakımı Paketi', old: '800 TL', price: '450 TL', desc: '3 Seans Derin Temizlik', icon: 'ri-leaf-line' },
            { name: 'Lazer Epilasyon', old: '3.000 TL', price: '1.800 TL', desc: 'Tüm Vücut 6 Seans', icon: 'ri-flashlight-line' },
            { name: 'ARC Cilt Yenileme', old: '4.000 TL', price: '2.500 TL', desc: '5 Seans Komple Paket', icon: 'ri-sparkling-2-line' },
          ].map((camp) => (
            <div key={camp.name} className="bg-white rounded-2xl p-6 border border-[#FFE5EC] hover:border-[#D4AF37]/40 transition-all duration-300 hover:-translate-y-1 group">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-gradient-to-br from-[#D4AF37]/20 to-[#FFB3C6]/20 mb-4">
                <i className={`${camp.icon} text-[#D4AF37] text-lg`}></i>
              </div>
              <h4 className="font-serif text-[#2D2D2D] font-bold mb-1">{camp.name}</h4>
              <p className="text-[#6B6B6B] text-xs mb-3">{camp.desc}</p>
              <div className="flex items-baseline gap-2 mb-4">
                <span className="text-[#6B6B6B] text-sm line-through">{camp.old}</span>
                <span className="text-[#D4AF37] font-bold text-xl">{camp.price}</span>
              </div>
              <a
                href={whatsapp(`${camp.name} kampanyası hakkında bilgi almak istiyorum.`)}
                target="_blank"
                rel="nofollow noreferrer"
                className="block text-center bg-[#FFF8F0] border border-[#D4AF37]/30 text-[#D4AF37] text-xs font-semibold py-2.5 rounded-full hover:bg-[#D4AF37] hover:text-white transition-colors whitespace-nowrap"
              >
                Kampanyadan Yararlan
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
